import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTransactionsByFitler,
  getTlogReportDependentDropdowns,
  getTlogReportTransactionDetail
} from "src/api/bi";
import {
  DependentDropDownPayloadRequest,
  SearchQueryPayload,
  TransactionDetailsQuery
} from "../interface";

export const fetchTransactionLogsByQuery = createAsyncThunk(
  "transactionLogReport/fetchTransactionLogsByQuery",
  (payload: SearchQueryPayload) => getTransactionsByFitler(payload)
);

export const fetchDependentDropdowns = createAsyncThunk(
  "fetchDependentDropdowns",
  (payload: DependentDropDownPayloadRequest) =>
    getTlogReportDependentDropdowns(payload)
);

export const fetchTransactionDetail = createAsyncThunk(
  "fetchTransactionDetail",
  (payload: TransactionDetailsQuery) => getTlogReportTransactionDetail(payload)
);
